export const DeviceTypeValues = [
    'Unknown',
    'MiniTrack',
    'MiniTrack_VIA_TimeRecorder',
    'EQMobile',
    'TimeRecorder',
    'OldTimeRecorder',
    'ETS_ECB',
    'ETS_ECB_VIA_TimeRecorder',
    'Ubidium',
    'VIA_EMIT',
    'ECU_VIA_TimeRecorder',
] as const;
export type DeviceType = (typeof DeviceTypeValues)[number];
